module.exports = __webpack_public_path__ + "static/FiraSans-Regular-9b3040e79b0e728dbe6ad51108457448.otf";